<script setup lang="ts">
import LandingTitleLayout from '../LandingTitleLayout.vue';
import AdvantageCard from '../AdvantageCard.vue';

const { staticUrl } = useRuntimeConfig().public;
const isExpanded = ref(false);
</script>

<template>
  <div id="differences" class="container differences">
    <LandingTitleLayout>
      <template #title>
        В чем
        <span>отличие</span>
        от других сервисов?
      </template>
    </LandingTitleLayout>

    <div class="differences__grid">
      <AdvantageCard
        :icon-src="`${staticUrl}/landing/difference6.png`"
        title="Система рейтинга"
        color="#f1f1ff"
      >
        Оставляя честный отзыв своему любимому мастеру ты лично влияешь на его
        рейтинг и помогаешь другим клиентам принять решение в выборе.
      </AdvantageCard>

      <AdvantageCard
        :icon-src="`${staticUrl}/landing/difference7.png`"
        title="Переносим красоту"
        color="#f7f7f8"
      >
        Планы резко изменились и ты не можешь попасть к мастеру? Не беда.
        Перенеси или отмени запись в личном кабинете.
      </AdvantageCard>

      <AdvantageCard
        :icon-src="`${staticUrl}/landing/difference8.png`"
        title="Без сюрпризов"
        color="#f1f6ff"
      >
        Не волнуйся, что в конце сеанса стоимость окажется выше. Мастер обязан
        указывать все дополнительные услуги.
      </AdvantageCard>

      <AdvantageCard
        class="differences__long-block-1"
        :icon-src="`${staticUrl}/landing/difference3.png`"
        title="Красота в удобстве"
        color="#f7f7f8"
        orientation="horizontal"
      >
        Освобождаем от необходимости переписываться с мастером и вести
        переговоры. Не нужно искать подход, подстраиваться под характер и его
        настроение.
      </AdvantageCard>

      <div v-if="!isExpanded" class="d-md-none">
        <AppButton variant="outlined" fluid @click="isExpanded = true">
          Смотреть все
        </AppButton>
      </div>

      <AdvantageCard
        class="differences__long-block-2"
        :class="[{ 'd-none': !isExpanded }, 'd-md-block']"
        :icon-src="`${staticUrl}/landing/difference4.png`"
        title="Запись без сбоев"
        color="#fcf5fc"
      >
        Удобнее и надежнее, чем запись через соц. сети или мессенджеры. Мастера
        не забудут о твоей записи и обязательно будут на связи.
      </AdvantageCard>

      <AdvantageCard
        :class="[{ 'd-none': !isExpanded }, 'd-md-block']"
        :icon-src="`${staticUrl}/landing/difference5.png`"
        title="Сохраняя историю"
        color="#f2f3fc"
      >
        Сервис сохраняет историю записи. Не нужно искать чаты с мастером, как
        это было раньше при записи через соц. сети или мессенджеры.
      </AdvantageCard>

      <AdvantageCard
        :class="[{ 'd-none': !isExpanded }, 'd-md-block']"
        :icon-src="`${staticUrl}/landing/difference1.png`"
        title="Мастера поблизости"
        color="#f2f3fc"
      >
        Найдем мастера в любой точке. Открой карту и больше не трать время на
        поездки в пробках.
      </AdvantageCard>
      <AdvantageCard
        class="differences__long-block-3"
        :class="[{ 'd-none': !isExpanded }, 'd-md-block']"
        :icon-src="`${staticUrl}/landing/difference2.png`"
        title="Не отрывая рук"
        color="#fcf5fc"
      >
        Не нравятся звонки? Запишись онлайн, а наш чат поможет обсудить все
        детали напрямую с мастером.
      </AdvantageCard>
    </div>
  </div>
</template>

<style scoped lang="scss">
.differences {
  &__grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;

    @include media-breakpoint-down(md) {
      display: flex;
      flex-direction: column;
    }
  }

  &__long-block-1 {
    grid-column-start: 1;
    grid-column-end: 4;
  }

  &__long-block-2 {
    grid-column-start: 1;
    grid-column-end: 3;
  }

  &__long-block-3 {
    grid-column-start: 2;
    grid-column-end: 4;
  }
}
</style>
